import React from 'react';
import {Link} from 'react-router-dom';
import Login from './Login';
import './HeaderMenu.scss';

const HeaderMenu = () => (
  <div className="header">
    <div className="header__inner">
      <Link to="/" className="header__logo">
        <h1>
          <img src="https://cdn.kr.riotgames.com/common/Fist_Red_48x48.png" alt="" />
          <img src="/image/layout/riot-games-pc-bang.svg" alt="라이엇 게임즈 프리미엄 PC방" />
        </h1>
      </Link>
      <ul className="header__links">
        <li data-qa="newEventHeader">
          <Link to="/news/notices">새소식/이벤트</Link>
        </li>
        <li data-qa="productsHeader">
          <Link to="/products/guide">상품안내/구매/쿠폰</Link>
        </li>
        <li data-qa="myPCBHeader">
          <Link to="/my-pc-bang/usage-status/payment-and-billing">MY PC방</Link>
        </li>
        <li data-qa="customerHeader">
          <Link to="/customer/faqs">고객센터</Link>
        </li>
      </ul>
      <Login />
    </div>
  </div>
);

export default HeaderMenu;
